import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type Delta from 'quill-delta';
import CommentModel from 'scaleflow/models/comment';

export interface IdeasCommentBoxSignature {
  // The arguments accepted by the component
  Args: {
    comment: CommentModel;
    index: number;
    editorModules: unknown;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class IdeasCommentBoxComponent extends Component<IdeasCommentBoxSignature> {
  @tracked editMode = false;
  @tracked hasErrors = false;

  get comment() {
    return this.args.comment;
  }

  @action
  toggleEditMode(val?: boolean): void {
    if (!this.args.comment.isMyComment) this.editMode = false;
    else if (val === undefined) this.editMode = !this.editMode;
    else this.editMode = val;
  }

  @action
  setCommentTextDelta(changeset: any, e: Delta) {
    changeset.set('text_delta', e);
  }

  @action
  async saveComment(changeset: any) {
    await changeset.validate();
    if (!changeset.get('isValid')) {
      this.hasErrors = true;
      return;
    } else {
      this.hasErrors = false;
    }
    changeset.set('idea', this.args.comment.idea.content);
    changeset.set('author', this.args.comment.author.content);

    changeset
      .save()
      .catch((err: any) => {
        console.debug(err);
        changeset.rollback();
      })
      .finally(() => {
        this.toggleEditMode();
      });
  }
}
